import React, { useEffect, useState } from 'react';
import P from 'prop-types';
import * as Styled from './AccountInfo.style.js';

import { useStore, connect } from 'react-redux';
import { getAddresses } from '@store/reducers/address/operations';
import {
  fetchPaymentMethods,
  setPaymentMethodsList,
  setCardBrands,
} from '@store/reducers/cart/operations';

import { deleteAccount } from '@services/user';
import { logout, getAllDataUser } from '@services/auth';

import { translate as t } from '@utils/translate';
import debounce from '@utils/debounce';

const AccountInfo = ({
  setOpen,
  address,
  paymentMethods,
  genericData,
  documentList,
}) => {
  const store = useStore();

  const [loading, setLoading] = useState(false);

  const user = getAllDataUser();

  const TEXTS = {
    NAME: t('name'),
    EMAIL: t('email'),
    BILLING_ADDRESS: t('billingAddress'),
    DOCUMENT: t('documentInput'),
    PAYMENT_INFO: t('paymentInfo'),
    DELETE: t('delete'),
    BACK: t('back'),
    ACCOUNT_INFO_DELETE: t('accountInfoDelete'),
  };

  const documentType = documentList?.find(
    document => document?.id === genericData?.documentTypeId
  );

  const fetchData = (fetchMethod, params) => {
    return new Promise(resolve => {
      store
        .dispatch(fetchMethod(params))
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  };

  const getData = async () => {
    const paymentMethodsResponse = await fetchData(fetchPaymentMethods);

    // Adress
    store.dispatch(getAddresses());

    // payment methods
    if (paymentMethodsResponse.result.status === 0) {
      store.dispatch(setCardBrands(paymentMethodsResponse.cardBrands));
      store.dispatch(
        setPaymentMethodsList(paymentMethodsResponse.paymentMethods)
      );
    }
  };

  const handleWithDeleteAccount = async () => {
    debounce(() => {
      deleteAccount({ id: user.id }).then(res => {
        if (res.status === 204) {
          logout();
        }
        setLoading(false);
      });
    }, 1500);
  };

  useEffect(() => {
    (async () => {
      getData();
    })();
  }, []);

  return (
    <Styled.Container>
      <Styled.ScrollContainer>
        <Styled.Title>{TEXTS.ACCOUNT_INFO_DELETE}</Styled.Title>

        <Styled.Info>
          <Styled.Label>{TEXTS.NAME}</Styled.Label>
          <Styled.Content>{genericData?.fullName}</Styled.Content>
        </Styled.Info>
        <Styled.Info>
          <Styled.Label>{TEXTS.EMAIL}</Styled.Label>
          <Styled.Content>{genericData?.emailAddress}</Styled.Content>
        </Styled.Info>
        {!!address?.addresses?.length && (
          <Styled.Info>
            <Styled.Label>{TEXTS.BILLING_ADDRESS}</Styled.Label>
            <Styled.ContentList>
              {address?.addresses?.map((currentAddress, i) => {
                return (
                  <Styled.ContentItem key={i}>
                    <Styled.ItemIndex>
                      {i + 1 < 10 ? '0' + (i + 1) : i + 1}
                    </Styled.ItemIndex>{' '}
                    {currentAddress?.line}
                  </Styled.ContentItem>
                );
              })}
            </Styled.ContentList>
          </Styled.Info>
        )}
        {!!genericData?.identityDocument && (
          <Styled.Info>
            <Styled.Label>{TEXTS.DOCUMENT}</Styled.Label>
            <Styled.ContentList>
              <Styled.ContentItem>
                <Styled.ItemIndex>{documentType?.name}</Styled.ItemIndex>{' '}
                {genericData?.identityDocument}
              </Styled.ContentItem>
            </Styled.ContentList>
          </Styled.Info>
        )}
        {!!paymentMethods.length && (
          <Styled.Info>
            <Styled.Label>{TEXTS.PAYMENT_INFO}</Styled.Label>
            <Styled.ContentList>
              {paymentMethods.map(infoPayment => {
                return (
                  <Styled.ContentItem
                    key={infoPayment.card.id}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Styled.ImgCard src={infoPayment.icon.url} />
                    <span>**** **** {infoPayment.card.lastDigits}</span>
                  </Styled.ContentItem>
                );
              })}
            </Styled.ContentList>
          </Styled.Info>
        )}
      </Styled.ScrollContainer>
      <Styled.ActionsBar>
        <Styled.Button
          type="button"
          loading={loading ? true : undefined}
          color="transparent"
          style={{ marginRight: 10 }}
          onClick={e => {
            setLoading(true);
            e.stopPropagation();
            handleWithDeleteAccount();
          }}
        >
          <span>{TEXTS.DELETE}</span>
        </Styled.Button>
        {!loading && (
          <Styled.Button
            type="button"
            color="#429488"
            onClick={e => {
              e.stopPropagation();
              setOpen(false);
            }}
          >
            {TEXTS.BACK}
          </Styled.Button>
        )}
      </Styled.ActionsBar>
    </Styled.Container>
  );
};

AccountInfo.propTypes = {
  setOpen: P.func,
  address: P.object,
  paymentMethods: P.array,
  genericData: P.object,
  documentList: P.array,
};

const mapStateToProps = state => ({
  address: state.address,
  paymentMethods: state.cart.paymentMethods,
});

export default connect(mapStateToProps)(AccountInfo);
